module.exports = __webpack_public_path__ + "img/Zajil.f1751ecc.svg";